var _defs, _ellipse, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReverseLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eJHvujU5TtV1",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJHvujU5TtV2-stroke",
    x1: 0.066987,
    y1: 0.25,
    x2: 0.933013,
    y2: 0.75,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eJHvujU5TtV2-stroke-0",
    offset: "0%",
    stopColor: "#6fd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eJHvujU5TtV2-stroke-1",
    offset: "100%",
    stopColor: "rgba(111,210,255,0.1)"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "eJHvujU5TtV2",
    rx: 4.285714,
    ry: 4.29878,
    transform: "matrix(1.75 0 0 1.744681 142.500005 200)",
    fill: "#6fd2ff",
    stroke: "url(#eJHvujU5TtV2-stroke)",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eJHvujU5TtV3",
    d: "M259.121872,142.594328h-76.358735",
    transform: "matrix(.8 0 0 0.8 37.000017 48.442133)",
    paintOrder: "markers stroke fill",
    fill: "none",
    stroke: "#6fd2ff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "eJHvujU5TtV4",
    d: "M0.051467,87.494383v125.000001h100",
    transform: "matrix(.8 0 0 0.8 40 30.004493)",
    paintOrder: "markers stroke fill",
    fill: "none",
    stroke: "#6fd2ff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "eJHvujU5TtV5",
    d: "M199.364606,87.499999l125,62.683413-125,62.5",
    transform: "matrix(0-.8 0.8 0 94.000082 359.491685)",
    paintOrder: "markers stroke fill",
    fill: "none",
    stroke: "#6fd2ff",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseLogo);
export default __webpack_public_path__ + "static/media/ReverseLogo.16087ad2a59c370f330766edd5f050dd.svg";
export { ForwardRef as ReactComponent };